<template>
  <div>
    <div class="flex flex-wrap items-center mb-4">
      <div class="w-full mb-2 text-stone-700 dark:text-stone-300">
        {{ t('optionsdialog.Sound') }}
      </div>
      <div class="w-full mb-2">
        <select v-model="myAfterSpinSound"
          class="w-full bg-white dark:bg-stone-700 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500 text-stone-700 dark:text-stone-200">
          <option v-for="sound in afterSpinSounds" :value="sound.value" :key="sound.value">
            {{ t(sound.name) }}
          </option>
        </select>
      </div>
      <div class="w-full flex items-center space-x-2">
        <button @click="playAfterSpinSound" :disabled="!playbackEnabled"
          class="inline-flex items-center justify-center px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm bg-white dark:bg-stone-700 text-stone-700 dark:text-stone-200 hover:bg-stone-50 dark:hover:bg-stone-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50">
          <i class="fas fa-play"></i>
        </button>
        <button @click="stopAfterSpinSound" :disabled="!playbackEnabled"
          class="inline-flex items-center justify-center px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm bg-white dark:bg-stone-700 text-stone-700 dark:text-stone-200 hover:bg-stone-50 dark:hover:bg-stone-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50">
          <i class="fas fa-stop"></i>
        </button>
      </div>
    </div>
    <div class="flex flex-wrap items-center">
      <div class="w-full mb-2 text-stone-700 dark:text-stone-300">
        {{ t('optionsdialog.Volume') }}
      </div>
      <div class="w-full">
        <div class="grid grid-cols-[auto,1fr,auto] items-center gap-3">
          <span class="text-xs text-stone-500 dark:text-stone-400">0</span>
          <input type="range" v-model.number="myAfterSpinSoundVolume" min="0" max="100" step="1"
            class="w-full h-2 bg-stone-200 dark:bg-stone-700 rounded-lg appearance-none cursor-pointer accent-primary-500">
          <span class="text-xs text-stone-500 dark:text-stone-400">100</span>
        </div>
        <div class="text-right text-sm font-medium text-stone-600 dark:text-stone-400 mt-1">
          {{ myAfterSpinSoundVolume }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import * as Util from '@utils/Util.js';
import * as Audio from '@services/audio/audio.js';

const { t, locale } = useI18n();
const emit = defineEmits(['set-after-spin-sound', 'set-after-spin-sound-volume']);
const props = defineProps({
  afterSpinSound: String,
  afterSpinSoundVolume: Number,
  firstTextOnWheel: String
});

const myAfterSpinSound = ref(props.afterSpinSound);
const myAfterSpinSoundVolume = ref(props.afterSpinSoundVolume);
const afterSpinSounds = Audio.getAfterSpinSounds();

const playbackEnabled = computed(() => myAfterSpinSound.value !== 'no-sound');

watch(myAfterSpinSound, (val) => emit('set-after-spin-sound', val));
watch(myAfterSpinSoundVolume, (val) => emit('set-after-spin-sound-volume', val));

function playAfterSpinSound() {
  Util.trackEvent('Wheel', 'PlayAfterSpinSoundInOptionsDialog', '');
  Audio.stopAfterSpinSound();
  Audio.playAfterSpin(
    myAfterSpinSound.value,
    props.firstTextOnWheel,
    myAfterSpinSoundVolume.value,
    locale.value
  );
}
function stopAfterSpinSound() {
  Util.trackEvent('Wheel', 'StopAfterSpinSoundInOptionsDialog', '');
  Audio.stopAfterSpinSound();
}
</script>
